/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'ptl-skeleton-small-card-item',
  templateUrl: './skeleton-small-card-item.component.html',
  styleUrls: ['./skeleton-small-card-item.component.scss'],
})
export class SkeletonSmallCardItemComponent {}
